import { Repository, EntityRepository } from 'typeorm';
import { GrnQtyRequest } from '../dto/grn-qty-request';
import { Grn } from '../grn.entity';


@EntityRepository(Grn)
export class GrnRepository extends Repository<Grn>{

    /**
     *
     * @param PurchaseOrderId the po id
     */
    async getGrnQty(poReq: GrnQtyRequest): Promise<any> {
        try {

            const prevAcceptedQyy = this.createQueryBuilder('Grn')
                .select(' sum(grnItemsInfo.acceptedQuantity) as quantity')
                .leftJoin('Grn.grnItemsInfo', 'grnItemsInfo')
                .where(` Grn.poId= '${poReq.purchaseOrderId}' and grnItemsInfo.saleOrderId='${poReq.saleOrderId}' and grnItemsInfo.itemCategoryId = '${poReq.itemCategoryId}' and grnItemsInfo.itemId = '${poReq.itemId}'`)
                .getRawOne();
            return prevAcceptedQyy;
        } catch (err) {
            throw err;
        }
    }

    async getGrnDataByPoId(poReq: GrnQtyRequest): Promise<any> {
        try {

            const grnData = this.createQueryBuilder('Grn')
                .select(' count(*) as count,max(grn_date) as grnDate')
                .where(` Grn.poId= '${poReq.purchaseOrderId}'`)
                .getRawOne();
            return grnData;
        } catch (err) {
            throw err;
        }
    }

    /**
     * 
     * @param grnId 
     * @returns 
     */
    async getGrnData(grnId: number): Promise<any> {
        const grnEntity = await this.createQueryBuilder("Grn")
            .leftJoinAndSelect('Grn.grnItemsInfo', 'grnItemsInfo')
            .where(` Grn.grnId= '${grnId}' `)
            .getOne();
        return grnEntity;
    }

}
